// resources
import * as BBApi from '.';
import moment from 'moment';
const rootUrl: string = BBApi.host + '/subscriptions';

export async function activeSubscriptions(period: '24h'|'48h'|'all', country?: number): Promise<number> {
	const url: URL = new URL(rootUrl + "/active");

	if (period === '24h') {
		const dateFrom = moment().startOf('day').utc().format()
		url.searchParams.append('dateFrom', dateFrom);
		url.searchParams.append('includeCancelled', 'true');
		url.searchParams.append('country', String(country));
	}

	if (period === '48h') {
		const dateFrom = moment().subtract(1, 'days').startOf('day').utc().format()
		url.searchParams.append('dateFrom', dateFrom);
		url.searchParams.append('includeCancelled', 'true');
		url.searchParams.append('country', String(country));
	}

	if (period === 'all') {
		url.searchParams.append('dateFrom', '2023-01-01');
		url.searchParams.append('country', String(country));
	}

	const response: Response = await BBApi.get(url.href);
	const { subscriptionCount } = await response.json();
	return subscriptionCount;
}

export type Location = { name: string, location: string }
export async function subscriberLocations(): Promise<any> {
  const url: URL = new URL(rootUrl + '/locations');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

  const subscriberLocations = await response.json();
	return subscriberLocations;
}

export type Subscriber = { username: string, birthYear: number, municipality: string, plan: string, state: string, first_period_start: string }
export async function latestSubscribers(): Promise<[Subscriber]> {
  const url: URL = new URL(rootUrl + '/latest-subscribers');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

  const latestSubscribers = await response.json();
	return latestSubscribers;
}

export type PlanDistribution = { monthly: number, halfyearly: number, yearly: number }
export async function planDistribution(): Promise<PlanDistribution> {
  const url: URL = new URL(rootUrl + '/plans/distribution');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

  const planDistribution = await response.json();
	return planDistribution;
}

export type RevenueValuesType = { newSubs: number, newSubsRevenue: number, renewingSubs: number, renewingSubsRevenue: number }
export async function revenueByDate(date: string): Promise<RevenueValuesType> {
	const url: URL = new URL(rootUrl + '/revenue-date');
	url.searchParams.append('date', date)

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const revenue = await response.json();
	return revenue;
}

export async function revenueByMonth(startOfMonth: string, startOfNextMonth: string): Promise<RevenueValuesType> {
	const url: URL = new URL(rootUrl + '/revenue-month');
	url.searchParams.append('startOfMonth', startOfMonth)
	url.searchParams.append('startOfNextMonth', startOfNextMonth)

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const revenue = await response.json();
	return revenue;
}
